<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.Roles & Permissions')
      }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20 page-content">
        <div>
          <el-button
            type="success"
            plain
            class="common-btn"
            @click="addRole()"
            v-if="p('Manage Module.Organisation.Roles & Permissions.Add')"
            >{{ $t('text.add_role') }}</el-button
          >
          <el-table border :data="roles" v-loading="loading" class="mt-20">
            <el-table-column :label="$t('text.role_name')" prop="RoleName">
            </el-table-column>
            <el-table-column
              :label="$t('text.action')"
              v-if="
                p('Manage Module.Organisation.Roles & Permissions.Edit') ||
                  p('Manage Module.Organisation.Roles & Permissions.Delete')
              "
            >
              <template slot-scope="scope">
                <div
                  class="blue-font underline pointer inline-block mr-10"
                  @click="view(scope.row)"
                  v-if="readOnlyRoles.includes(scope.row.RoleName)"
                >
                  {{ $t('text.view') | firstLetterCapitalize }}
                </div>
                <div v-else>
                  <div
                    class="blue-font underline pointer inline-block mr-10"
                    @click="edit(scope.row)"
                    v-if="
                      p('Manage Module.Organisation.Roles & Permissions.Edit')
                    "
                  >
                    {{ $t('text.edit') | firstLetterCapitalize }}
                  </div>
                  <div
                    class="red-font underline pointer inline-block"
                    @click="deleteRow(scope.row)"
                    v-if="
                      p('Manage Module.Organisation.Roles & Permissions.Delete')
                    "
                  >
                    {{ $t('text.delete') | firstLetterCapitalize }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <addRole ref="addRole" />
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import AddRole from '@/components/manage/admin/AddRole.vue'
import swal from 'sweetalert'
import { readOnlyRoles } from '@/const'
export default {
  data() {
    return {
      readOnlyRoles,
      loading: false,
      roles: []
    }
  },
  components: {
    AddRole
  },
  mounted() {
    this.getRoles()
  },
  methods: {
    getRoles() {
      this.roles = []
      this.loading = true
      ApiService.GetRoles(this.$store.getters[`user/selecteOrganisationId`])
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.roles = response.data.data
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    addRole() {
      this.$refs.addRole.openDialog()
    },
    view(row) {
      this.$refs.addRole.form.Id = row.Id
      this.$refs.addRole.isReadonly = true
      this.$refs.addRole.openDialog()
    },
    edit(row) {
      this.$refs.addRole.form.Id = row.Id
      this.$refs.addRole.openDialog()
    },
    deleteRow(row) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.delete_role_confirm'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        row.RoleName + ' ' + this.$t('text.deletion'),
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDeleteRole(row.Id)
        })
        .catch(() => {})
    },
    handleDeleteRole(id) {
      ApiService.DeleteRole(id)
        .then(response => {
          if (response.data.success) {
            this.getRoles()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Deleted Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Deleted Failed'
          })
        })
    }
  }
}
</script>
